<template>
<div class="field config-list-type">
    <label class="label">Default List</label>
    <p class="help">
        {{ selectedOpt.desc }}
    </p>
    <div class="control">
        <span class="select is-small">
            <select :value="value" @change="$emit('input', $event.target.value)">
                <option v-for="opt in listOpts" :value="opt.val" :key="opt.val">
                    {{ opt.text }}
                </option>
            </select>
        </span>
    </div>
</div>
</template>

<script>
import * as C from '@shared/constants'
import * as M from '@/store/mutations'

export default {
    name: 'ConfigListType',
    props: {
        value: String
    },
    data: vm => ({
        // TODO: DRY this list up with the list in Toolbar.vue
        listOpts: [
            {
                val: C.LIST_TYPE_VOTES,
                text: vm.$t('top'),
                desc: 'Show most upvoted posts first.',
            },
            {
                val: C.LIST_TYPE_DATE,
                text: vm.$t('new'),
                desc: 'Show most recent posts first.',
            },
            {
                val: C.LIST_TYPE_BROADCASTER_LIKES,
                text: vm.$t('streamerLikes'),
                desc: 'Only show posts that you upvoted.',
            },
            {
                val: C.LIST_TYPE_BROADCASTER_POSTS,
                text: vm.$t('streamerPosts'),
                desc: 'Only show posts that you created.',
            },
        ]
    }),
    computed: {
        selectedOpt: vm => vm.listOpts.find(o => o.val === vm.value),
    },
    watch: {
        value (listType) {
            // Update the sbox, since this is a live preview.
            this.$store.commit(M.SET_LIST_FILTERS, { listType })
        }
    }
}
</script>

<style lang="scss" scoped>
.config-list-type {
    select, option {
        text-transform: capitalize;
    }
}
</style>
